import { render, staticRenderFns } from "./declaration-element.vue?vue&type=template&id=1e61265c"
import script from "./declaration-element.vue?vue&type=script&lang=ts"
export * from "./declaration-element.vue?vue&type=script&lang=ts"
import style0 from "./declaration-element.vue?vue&type=style&index=0&id=1e61265c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports